import React__default from 'react';
import PropTypes from 'prop-types';
import { StyledHeader, MenuControlContainer, LogoContainer, LogoTextContainer } from './SideNavigationHeader.styles.js';
import ButtonIcon from '../../Inputs/Button/ButtonIcon/ButtonIcon.js';
import { useSideNavigationThemeContext } from '../SideNavigationContexts/SideNavigationThemeContext.js';

var menuIcons = {
  nonTouch: {
    close: 'DoubleChevronRight',
    open: 'DoubleChevronLeft'
  },
  touch: {
    close: 'HamburgerMenu',
    open: 'Close'
  }
};
var getIcon = function getIcon(isTouch, isOpen) {
  var viewPort = isTouch ? 'touch' : 'nonTouch';
  var state = isOpen ? 'open' : 'close';
  return menuIcons[viewPort][state];
};
var SideNavigationHeader = function SideNavigationHeader(_ref) {
  var logoIcon = _ref.logoIcon,
    logoText = _ref.logoText,
    _ref$onClick = _ref.onClick,
    onClick = _ref$onClick === void 0 ? undefined : _ref$onClick,
    _ref$optionalControl = _ref.optionalControl,
    optionalControl = _ref$optionalControl === void 0 ? undefined : _ref$optionalControl,
    _ref$testId = _ref.testId,
    testId = _ref$testId === void 0 ? undefined : _ref$testId;
  var _useSideNavigationThe = useSideNavigationThemeContext(),
    isTouch = _useSideNavigationThe.isTouch,
    isOpen = _useSideNavigationThe.isOpen;
  var icon = getIcon(isTouch, isOpen);
  var isTouchAndOpen = isTouch && isOpen;
  var shouldDisplayOptionalControl = isTouchAndOpen && optionalControl;
  return React__default.createElement(StyledHeader, {
    $isOpen: isOpen,
    $isTouch: isTouch,
    "data-testid": testId
  }, onClick && React__default.createElement(MenuControlContainer, {
    $isTouch: isTouch
  }, React__default.createElement(ButtonIcon, {
    icon: icon,
    variant: "ghost",
    ariaLabel: isOpen ? 'Close Menu' : 'Open Menu',
    onClick: onClick
  })), React__default.createElement(LogoContainer, {
    $isOpen: isOpen,
    $isTouch: isTouch
  }, logoIcon, React__default.createElement(LogoTextContainer, null, logoText)), React__default.createElement("span", null, shouldDisplayOptionalControl && optionalControl));
};
SideNavigationHeader.propTypes = {
  logoIcon: PropTypes.node.isRequired,
  logoText: PropTypes.node.isRequired,
  onClick: PropTypes.func,
  optionalControl: PropTypes.node,
  testId: PropTypes.string
};

export { SideNavigationHeader, SideNavigationHeader as default };
//# sourceMappingURL=SideNavigationHeader.js.map
